import { parse, format } from "date-fns";

export const formatPID = (uid) => {
  if (uid && uid.length === 8) {
    return `${uid[0]}${uid[1]}-${uid[2]}${uid[3]}${uid[4]}-${uid[5]}${uid[6]}${uid[7]}`;
  } else {
    return uid;
  }
};

export const parsePID = (uid) => {
  return uid.replace(/-/g, "").replace(/\s/g, "");
};

export const isUnauthorised = (responseStatus) => {
  return (
    responseStatus &&
    !responseStatus["success"] &&
    responseStatus["code"] === 4011 &&
    responseStatus["message"] === "Unauthorized request"
  );
};

const getEnv = () => {
  if (window.location.hostname === "staging.ic4.health") {
    return "staging";
  } else if (window.location.hostname === "ic4.health") {
    return "production";
  } else if (window.location.hostname.indexOf("localhost") !== -1) {
    return "development";
  } else {
    return "unknown";
  }
};

const getAllStorage = () => {
  try {
    const keys = Object.keys(localStorage);
    let toReturn = [];
    for (let i = 0; i < keys.length; i++) {
      const _key = keys[i];
      if (_key != "token") {
        toReturn.push([_key, localStorage.getItem(_key)]);
      }
    }
    return toReturn;
  } catch (e) {
    return [];
  }
};

export const getPerson = () => {
  try {
    return {
      id: localStorage.getItem("pid")
        ? localStorage.getItem("pid")
        : "USER_NOT_AUTHENTICATED",
      props: getAllStorage(),
    };
  } catch (e) {
    return {
      id: "ERR_USER",
      props: [],
    };
  }
};

export const rollbarConfig = {
  accessToken: "828e6df9cc1441fdb6dcb16691829ce6",
  autoInstrument: true,
  environment: getEnv(),
  server: {
    root: window.location.hostname,
    branch: "main",
  },
  code_version: "3.0.0-react",
  person: localStorage.getItem("pid")
    ? { id: localStorage.getItem("pid") }
    : null,
};

export const rollbarConfigV2 = {
  accessToken: "828e6df9cc1441fdb6dcb16691829ce6",
  captureUncaught: true,
  captureUnhandledRejections: true,
  autoInstrument: true,
  payload: {
    environment: getEnv(),
    person: getPerson(),
    //trace_id: 'abc',
    client: {
      javascript: {
        code_version: "3.0.0-react",
        source_map_enabled: true,
        //guess_uncaught_frames: true
      },
    },
    server: {
      host: window.location.hostname,
      branch: "main",
    },
    //server: {
    //root: 'http://localhost:8000/demo/',
    //host: 'host-1',
    //branch: 'HEAD',
    //},
  },
};

const numberMap = {
  "१": "1",
  "२": "2",
  "३": "3",
  "४": "4",
  "५": "5",
  "६": "6",
  "७": "7",
  "८": "8",
  "९": "9",
  "०": "0",
};

// Convert numbers from hindi and marathi to english
export const parseNumberFromAnotherLocale = (numericValue) => {
  if (isNaN(numericValue)) {
    const _numericValue = numericValue.toString();
    console.log("attempting to convert number");
    let returnNumberValue = "";
    for (let i = 0; i < _numericValue.length; i++) {
      const convertedCharacter = numberMap[_numericValue[i]];
      if (isNaN(convertedCharacter)) {
        throw "Failed to convert value: " + _numericValue;
      } else {
        returnNumberValue += convertedCharacter;
      }
    }
    return returnNumberValue;
  } else {
    // the input is already a valid number just return it
    return numericValue;
  }
};

export function isValidPincode(input) {
  const pinCodePattern = /^[1-9][0-9]{5}$/; // 6 digits, first digit cannot be 0
  return pinCodePattern.test(input);
}
export function isDevanagariPincode(input) {
  const devanagariPattern = /^[०-९]{6}$/; // 6 Devanagari digits only
  return devanagariPattern.test(input);
}

export function isValidDate(dateString) {
  const parsedDate = new Date(dateString);
  // Check if the parsedDate is a valid date and not equal to 'Invalid Date'
  return !isNaN(parsedDate) && parsedDate.toString() !== "Invalid Date";
}

// Convert date from hindi and marathi to english
export const parseDateIfFromAnotherLocale = (date) => {
  return [...date]
    .map((char) => {
      return char === "-" ? "-" : numberMap[char];
    })
    .join("");
};

export const getIC4ID = (patientId) => {
  const cleanedPID = parsePID(patientId);
  return parseNumberFromAnotherLocale(cleanedPID);
};

export const getAgeFromDate = (dateValue) => {
  const currentYear = new Date().getFullYear();
  if (
    dateValue &&
    typeof dateValue === "string" &&
    dateValue.indexOf("/") !== -1
  ) {
    return currentYear - parseInt(dateValue.split("/")[0]);
  } else {
    return "";
  }
};

//This function is used in recommended appointment booking date reminder
export const convertDateFormat = (inputDate) => {
  const parsedDate = parse(inputDate, "dd MMM yyyy", new Date());
  const formattedDate = format(parsedDate, "yyyy-MM-dd");
  return formattedDate;
};

export const stripNumbers = (str) => (str ? str.replace(/[0-9]/g, "") : "");

export const getFullName = (patientDetail) => {
  if (patientDetail) {
    return `${stripNumbers(patientDetail.firstName)} ${stripNumbers(
      patientDetail.middleName
    )} ${stripNumbers(patientDetail.lastName)}`;
  } else {
    return "";
  }
};

export const getTranslatedClinicNameFromId = (clinicId, t) => {
  console.log(clinicId, "clinicTranslator");
  switch (clinicId) {
    case "CC000000":
      return t("appointment.CONFIRMED.clinic0");
    case "CC000007":
      return t("appointment.CONFIRMED.clinic0");
    case "CC000001":
      return t("appointment.CONFIRMED.clinic1");
    case "CC000002":
      return t("appointment.CONFIRMED.clinic2");
    case "CC000003":
      return t("appointment.CONFIRMED.clinic3");
    case "CC000004":
      return t("appointment.CONFIRMED.clinic4");
    case "CC000005":
      return t("appointment.CONFIRMED.clinic5");
    case "CC000006":
      return t("appointment.CONFIRMED.clinic6");
    case "CC000008":
      return t("appointment.CONFIRMED.clinic8");
    case "CC000009":
      return t("appointment.CONFIRMED.clinic9");
    case "CC000010":
      return t("appointment.CONFIRMED.clinic10");
    case "CC000011":
      return t("appointment.CONFIRMED.clinic11");
    case "CC000012":
      return t("appointment.CONFIRMED.clinic12");
    case "CC000013":
      return t("appointment.CONFIRMED.clinic13");
    case "CC000014":
      return t("appointment.CONFIRMED.clinic14");
    case "CC000015":
      return t("appointment.CONFIRMED.clinic15");
    case "CC000016":
      return t("appointment.CONFIRMED.clinic16");
    case "CC000017":
      return t("appointment.CONFIRMED.clinic17");
    case "CC000018":
      return t("appointment.CONFIRMED.clinic18");
    case "CC000019":
      return t("appointment.CONFIRMED.clinic19");
    case "CC000020":
      return t("appointment.CONFIRMED.clinic20");
    case "CC000021":
      return t("appointment.CONFIRMED.clinic21");
    case "CC000022":
      return t("appointment.CONFIRMED.clinic22");
    case "CC000023":
      return t("appointment.CONFIRMED.clinic23");
    case "CC000024":
      return t("appointment.CONFIRMED.clinic24");

    default:
      return t("appointment.CONFIRMED.clinic1");
  }
};

export const getBaseUrl = () => {
  const host = window.location.hostname;
  if (host === "localhost" || host === "127.0.0.1") {
    return "https://staging.ic4.health";
  }
  return `${window.location.origin}`;
};
